/* 3RD MAY 24.09.2026 — "Zurueck auf Lager" (Klaviyo-Formular "Warteliste PDP").
   Klaviyos Button haengt an der klebenden Kaufleiste (.product-sticky-form) und bleibt dort.
   In der Kaufbox steht eine Schaltflaeche im Theme-Stil, die ihn ausloest: gleiche Zeile wie die
   Mengenauswahl, gleiche Schriftgroesse wie "In den Warenkorb". Weil der Platz dort je nach Geraet
   knapp ist (30px Innenabstand!), waehlt sie automatisch die laengste Beschriftung, die einzeilig
   passt. Ist die Variante wieder lieferbar, verschwindet sie und "In den Warenkorb" kommt zurueck. */
(function () {
  var BOX = '.ed-quantity-atc-container';
  var MARKE = 'data-3rdm-bis';
  var css = document.createElement('style');
  css.textContent =
    '.ed-quantity-atc-container.bis-aktiv > .product-form__add-button:not([' + MARKE + ']){display:none !important}' +
    '.ed-quantity-atc-container [' + MARKE + ']{flex:1 1 auto}' +
    '@media (max-width:749px){.ed-quantity-atc-container [' + MARKE + ']{padding-left:12px;padding-right:12px}}' +
    // In der klebenden Kaufleiste steht Klaviyos eigener Button. Am Desktop ist er
    // schmaler (178px) als der Theme-Button daneben (202px), darum brach die
    // Beschriftung dort auf zwei Zeilen. Gleiche Breite, eine Zeile.
    '@media screen and (min-width:1000px){.product-sticky-form button[class*="kl-private-reset-css"]' +
    '{min-width:210px;white-space:nowrap}}';
  (document.head || document.documentElement).appendChild(css);

  function klaviyoButton() {
    return [].slice.call(document.querySelectorAll('button[class*="kl-private-reset-css"]'))
      .filter(function (b) { return /warteliste|benachrichtig|notify/i.test(b.innerText || ''); })[0];
  }
  function varianten(text) {
    var voll = (text || 'Auf die Warteliste setzen').replace(/\s+/g, ' ').trim();
    var ohneDie = voll.replace(/\bdie\b\s*/i, '').replace(/\s+/g, ' ').trim();
    var kurz = ohneDie.replace(/\s*setzen$/i, '').trim();
    var minimal = kurz.replace(/^auf\s+/i, '').trim();
    return [ohneDie, kurz, minimal].filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }
  function passtEinzeilig(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    return r.getClientRects().length <= 1;
  }
  // Reihenfolge: lieber die vollstaendige Beschriftung eine Spur kleiner als eine kuerzere.
  // Untergrenze 10px - darunter wird es auf dem Handy unleserlich.
  function beschriften(el, text) {
    var liste = varianten(text);
    el.style.fontSize = '';
    // Ohne fertiges Layout (Breite 0) misst jede Probe falsch - dann die volle
    // Beschriftung setzen und spaeter erneut messen, statt unnoetig zu kuerzen.
    if (el.clientWidth < 40) { el.textContent = liste[0]; return; }
    var basis = parseFloat(getComputedStyle(el).fontSize) || 12;
    var groessen = [basis, basis - 0.5, basis - 1, basis - 1.5, basis - 2]
      .filter(function (g) { return g >= 10; });
    for (var i = 0; i < liste.length; i++) {
      for (var j = 0; j < groessen.length; j++) {
        el.textContent = liste[i];
        el.style.fontSize = groessen[j] === basis ? '' : groessen[j] + 'px';
        if (passtEinzeilig(el)) return;
      }
    }
  }
  function pflegen() {
    var box = document.querySelector(BOX);
    if (!box) return;
    var kl = klaviyoButton();
    var eigener = box.querySelector('[' + MARKE + ']');
    if (kl) {
      if (!eigener) {
        eigener = document.createElement('button');
        eigener.type = 'button';
        eigener.setAttribute(MARKE, '');
        eigener.className = 'product-form__add-button button button--primary';
        eigener.addEventListener('click', function () {
          var b = klaviyoButton();
          if (b) b.click();
        });
        box.appendChild(eigener);
      }
      var quelle = (kl.innerText || '').trim();
      if (eigener.getAttribute('data-quelle') !== quelle) {
        eigener.setAttribute('data-quelle', quelle);
        beschriften(eigener, quelle);
      }
      box.classList.add('bis-aktiv');
    } else {
      if (eigener) eigener.remove();
      box.classList.remove('bis-aktiv');
    }
  }
  function neuBeschriften() {
    var e = document.querySelector(BOX + ' [' + MARKE + ']');
    if (e) beschriften(e, e.getAttribute('data-quelle'));
  }
  function start() {
    pflegen();
    new MutationObserver(pflegen).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', neuBeschriften);
    window.addEventListener('load', neuBeschriften);
    // Solange die Hausschrift nicht geladen ist, misst der Browser mit der breiteren
    // Ersatzschrift - das hat die Beschriftung einmal unnoetig auf "Warteliste" gekuerzt.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(neuBeschriften);
    setTimeout(neuBeschriften, 1500);
    // Beim ersten Laden steht die Breite der Kaufbox oft noch nicht fest - dann misst die
    // Beschriftung zu frueh und faellt unnoetig auf die Kurzform zurueck. Der Beobachter
    // richtet sie neu aus, sobald sich die Breite der Box aendert (die Schriftgroesse
    // der Schaltflaeche aendert die Boxbreite nicht, also keine Endlosschleife).
    if (window.ResizeObserver) {
      var box = document.querySelector(BOX);
      if (box) {
        var letzte = 0;
        new ResizeObserver(function () {
          var b = Math.round(box.clientWidth);
          if (b && b !== letzte) { letzte = b; neuBeschriften(); }
        }).observe(box);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
